module.exports = __webpack_public_path__ + "static/media/mini_batman.e7f6ffb3.png";